<template>
    <div>
        <h1 class="display-heading">Medicine Delivery</h1>

        <div class="card mb-5">
            <div class="card-body">
                <appointment-detail participantNameDisplay="Patient Name" :isConsultation="true" :consultationId="consultation.consultationId" :appointmentDate="consultation.startTime" :appointmentParticipant="consultation.participantName" :isDoctor="true" :patientGender="consultation.patientGender" :patientAge="consultation.patientAge" :shouldShowPatientMailingAddress="true" :patientMailingAddress="consultation.patientAddress">

                    <!-- consultation.doctorName -->
                </appointment-detail>
            </div>
        </div>

        <div class="mb-5">
            <h5 class="mb-3">Medicine Charges</h5>
            <div class="d-flex align-items-center mb-3">
                <div class="mr-2"><b>Status: </b></div>
                <span class="badge text-nowrap" :class="getMedicineChargesBadgeClass(medicineStatus)">
                    {{getMedicineChargesStatus(medicineStatus)}}
                </span>
            </div>
            <doctor-consultation-price ref="doctorConsultationPrice" :isConsultationInProgress="false" v-model="form.doctorConsultationPriceList" :totalPrice="consultationItemTotalPrice">

            </doctor-consultation-price>
        </div>

        <div class="card">
            <div class="card-header">Medicine Delivery</div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-3"><b>Current Status</b></div>
                    <div class="col-md-9">
                        {{getMedicineChargesStatus(medicineStatus)}}
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3"><b>Update Delivery Status</b></div>
                    <div class="col-md-9">
                        <template v-if="medicineStatus===2">
                            <button class="btn btn-primary btn-primary-insv" @click="updateDeliveryStatus">Update to Delivered</button>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Update Medicine Delivery Status">
            <template slot="content">
                <p>{{confirmationMessage}}</p>
            </template>
            <template slot="footer">
                <template v-if="medicineStatus===2">
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="confirmUpdateDeliveryStatus">Confirm</button>
                    <button type="button" class="btn btn-secondary" @click="dismissUpdateDeliveryStatus">Cancel</button>
                </template>
                <template v-else>
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissUpdateDeliveryStatus">Done</button>
                </template>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import {
    doctorConsultationNoPharmacyPrescriptionStatus,
    getEnumDisplay,
    getEnumBadgeClass
} from '@/config/enums';
import {
    replaceLineBreakInHtml,
    convertToUserReadableDate
} from '@/utilities';
import appointmentDetail from '@/components/appointment-detail';
import doctorConsultationPrice from '@/components/doctor-consultation-price';
export default {
    'name': 'DoctorConsultationDetails',
    'components': {
        appointmentDetail,
        doctorConsultationPrice,
        popupModal
    },
    'computed': {
        consultationId () {
            return this.$route.params.id;
        }
    },
    data () {
        return {
            convertToUserReadableDate,
            replaceLineBreakInHtml,
            'form': {
                'da': null,
                'ea': null,
                'la': null,
                'm': null,
                'ai': null,
                'c': null,
                'dal': null,
                'pai': null,
                'cm': null,
                'icdCodes': [],
                'pharmacyId': null,
                'doctorConsultationPriceList': []
            },
            'consultationItemTotalPrice': 0,
            'consultation': {
                'startTime': null,
                'consultationId': null,
                'participantName': null,
                'doctorName': null,
                'patientGender': '',
                'patientAge': '-1',
                'patientContact': '',
                'patientEmail': '',
                'patientAddress': ''
            },
            'consultationStatus': 0,
            'medicineStatus': 0,
            'confirmationMessage': ''
        };
    },
    mounted () {
        this.getMedicineDelivery();
    },
    'methods': {
        getMedicineDelivery () {
            if (this.consultationId) {
                this.axios.get('Consultation/GetConsultationDetails', {
                    'params': {
                        'consultationId': this.consultationId
                    }
                }).then(({
                    data
                }) => {
                    let consultation = data.data;

                    this.consultation.startTime = consultation.st;
                    this.consultation.consultationId = consultation.cis;
                    this.consultation.participantName = consultation.u ? consultation.u.fn : null;
                    this.consultation.doctorName = consultation.d ? consultation.d.n : null;
                    this.consultation.patientGender = consultation.u ? consultation.u.g : null;
                    this.consultation.patientAge = consultation.u ? consultation.u.a : -1;
                    this.consultation.patientContact = consultation.u ? consultation.u.pn : null;
                    this.consultation.patientEmail = consultation.u ? consultation.u.e : null;

                    if (consultation.up) {
                        let mailingAddressLines = [consultation.up.mal1];

                        if (consultation.up.mal2) {
                            mailingAddressLines.push(consultation.up.mal2);
                        }
                        mailingAddressLines.push(`${consultation.up.map}, ${consultation.up.mac}`);
                        mailingAddressLines.push(consultation.up.mas);

                        this.consultation.patientAddress = mailingAddressLines.join('<br />');
                    }

                    this.form.da = consultation.da;
                    this.form.ea = consultation.ea;
                    this.form.la = consultation.la;
                    this.form.m = consultation.m;
                    this.form.ai = consultation.ai;
                    this.form.c = consultation.c;
                    this.form.dal = consultation.dal;
                    this.form.pai = consultation.pai;
                    this.form.cm = consultation.cm;

                    this.consultationStatus = consultation.cs;

                    this.form.pharmacyId = consultation.phid;

                    if (consultation.cnpd && consultation.cnpd.ci) {
                        this.form.doctorConsultationPriceList = consultation.cnpd.ci.map((item) => ({
                            'type': item.t,
                            'name': item.n,
                            'price': item.p
                        }));

                        this.consultationItemTotalPrice = consultation.cnpd.ps ? consultation.cnpd.ps.pspt : 0;

                        this.medicineStatus = consultation.cnpd.s;
                    }
                }).catch(() => {});
            }
        },
        getMedicineChargesStatus (statusId) {
            return getEnumDisplay(doctorConsultationNoPharmacyPrescriptionStatus, statusId);
        },
        getMedicineChargesBadgeClass (statusId) {
            return getEnumBadgeClass(doctorConsultationNoPharmacyPrescriptionStatus, statusId);
        },
        updateDeliveryStatus () {
            this.confirmationMessage = 'Are you sure you want to update the medicine delivery status? This action cannot be undone!';
            this.$refs.popupModalConfirmation.show();
        },
        confirmUpdateDeliveryStatus () {
            this.confirmationMessage = 'Updating medicine delivery status...';
            this.axios.post('Consultation/UpdateDoctorMedicineDeliveryStatus', {
                'ci': this.consultationId,
                'id': true
            }).then(({ data }) => {
                this.confirmationMessage = 'Medicine delivery status updated successfully!';
                this.getMedicineDelivery();
            }).catch(() => {
                this.confirmationMessage = 'Error updating medicine delivery status. Please try again.';
            });
        },
        dismissUpdateDeliveryStatus () {
            this.$refs.popupModalConfirmation.hide();
        }
    }
};
</script>

<style>

</style>
